/**
 * Unwraps a service layer result tuple, returning the data on success or
 * throwing the error on failure. Use in TanStack Query `queryFn` and
 * `mutationFn` to bridge the `{ data, error }` pattern with TanStack's
 * throw-on-error expectation.
 */
export function unwrapOrThrow<T>({
  data,
  error,
}: {
  data: T | null
  error: Error | null
}): T {
  if (error) throw error
  return data as T
}
